var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.64,
    height: 21.061,
    viewBox: "0 0 20.64 21.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_googleg_48dp",
    "data-name": "logo googleg 48dp",
    transform: "translate(-14 -14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M33.109,23.518a12.023,12.023,0,0,0-.192-2.154H23v4.073h5.668a4.845,4.845,0,0,1-2.1,3.178v2.643h3.4a10.272,10.272,0,0,0,3.14-7.74Z",
    transform: "translate(1.531 1.252)",
    fill: "#4285f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M24.368,33.24a10.055,10.055,0,0,0,6.969-2.551l-3.4-2.643a6.354,6.354,0,0,1-9.459-3.336H14.957v2.729a10.528,10.528,0,0,0,9.411,5.8Z",
    transform: "translate(0.163 1.821)",
    fill: "#34a853",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M18.638,25.688a6.231,6.231,0,0,1,0-4V18.958H15.12a10.547,10.547,0,0,0,0,9.459l3.518-2.729Z",
    transform: "translate(0 0.843)",
    fill: "#fbbc05",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M24.368,18.189a5.69,5.69,0,0,1,4.025,1.574l3.021-3.02A10.123,10.123,0,0,0,24.368,14a10.528,10.528,0,0,0-9.411,5.8l3.518,2.729a6.276,6.276,0,0,1,5.892-4.341Z",
    transform: "translate(0.163)",
    fill: "#ea4335",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGoogle);
export default __webpack_public_path__ + "static/media/logo_google.36c4eb9351ecdb72d542fb8a5852c129.svg";
export { ForwardRef as ReactComponent };